module.exports = __webpack_public_path__ + "static/img/2.81788f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/sp/2.png
// module id = 7HoG
// module chunks = 0